const FOCUSABLE_SELECTOR =
  'button, [tabindex]:not([tabindex="-1"]), input, select, textarea, a[href], [role="button"]';

const TOOLBAR_SELECTOR = '[data-test="student-toolbar"]';

type FocusFirstTabbableOptions = {
  targetId: string;
};

export const focusFirstTabbableInTarget = ({
  targetId,
}: FocusFirstTabbableOptions): boolean => {
  const targetElement = document.getElementById(targetId);
  if (!targetElement) {
    return false;
  }

  targetElement.focus();
  targetElement.scrollIntoView({ behavior: 'smooth' });

  setTimeout(() => {
    const focusableElements = targetElement.querySelectorAll(FOCUSABLE_SELECTOR);
    const toolbarElement = document.querySelector(TOOLBAR_SELECTOR);
    const filteredElements = Array.from(focusableElements).filter((element) => {
      return !toolbarElement?.contains(element);
    });

    if (filteredElements.length > 0) {
      (filteredElements[0] as HTMLElement).focus();
    }
  }, 100);

  return true;
};
